import React from 'react';
import PropTypes from 'prop-types';

import SkeletonTable from './SkeletonTable';
import SkeletonCards from './SkeletonCards';

const Loader = ({
  loading,
  variant,
  children,
}) => {
  if (!loading) {
    return children;
  }

  return variant === 'cardList' ? <SkeletonCards /> : <SkeletonTable />;
};

Loader.defaultProps = {
  children: null,
  loading: false,
  variant: 'table',
};

Loader.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.bool,
  variant: PropTypes.string,
};

export default Loader;
